module.exports = __webpack_public_path__ + "img/zhifu.ba775b38.png";